// extracted by mini-css-extract-plugin
export default {"Main":"unconfirmed__Main__E6GzF"};